export default __webpack_public_path__ + "assets/images/b0585f3bb95eba02c2ea39a13238a319.svg";